export const leftArrowIcon = `
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.95652 3L9 4.05077L3.836 9.25H20V10.75H3.838L9 15.9492L7.95652 17L2.048 11.05L2.04348 11.0559L1 10.0052L7.95652 3Z" fill="#A1A1A1"/>
</svg>
`;
